import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";

export default function LandingPage() {
  return (
    <main className="pp-shell relative overflow-hidden flex items-center justify-center p-6">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.32]"
        style={{
          background:
            "radial-gradient(700px circle at 20% -10%, rgba(176,38,255,0.35), transparent 55%), radial-gradient(600px circle at 90% 10%, rgba(45,124,255,0.28), transparent 50%)",
        }}
        aria-hidden
      />
      <section className="pp-card relative z-[1] w-full max-w-xl p-8 sm:p-10 shadow-ppCard">
        <div className="mb-6 flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <Logo variant="full" raster className="max-w-full" />
          <span className="pp-badge-soft w-fit">Mom Test intelligence</span>
        </div>
        <h1 className="text-2xl font-bold tracking-tight text-pp-main">
          Detectá pains reales antes de invertir tiempo.
        </h1>
        <p className="mt-4 text-base leading-relaxed text-pp-muted">
          PainPulse AI combina encuestas multi-negocio, insights y herramientas de admin para corroborar iniciativas
          con evidencia cualitativa fuerte — sin jargon.
        </p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/admin" className="pp-btn-primary">
            Ir al panel
          </Link>
          <Link to="/survey/vinculos" className="pp-btn-secondary">
            Abrir encuesta pública
          </Link>
        </div>
      </section>
    </main>
  );
}
